export const DEFAULT_MEASUREMENT = {
    value: "",
    uom: "",
};

export const DEFAULT_RANGE = {
    selectedTitle: "",
    selectedValue: [],
    label: "",
    low: DEFAULT_MEASUREMENT,
    high: DEFAULT_MEASUREMENT,
    legendText: "",
};
